var bighouse = bighouse || {};

bighouse.share = (function () {

    function init(){

        $('.js-lightboxOpenShare').on('click', function(e){

            if(window.navigator.share !== undefined) {
                window.navigator.share({
                    title: document.title,
                    text: $('#share-sheet-text').val(),
                    url: document.location,
                    }); 
            } else {
                bighouse.lightbox.lightboxOpenFunc(e);
            }
        });
    }


    return {
        init: init
    };
})();